import { ReactNode, useEffect, useRef } from 'react'

import { useTranslation } from 'react-i18next'

import TickRegularIcon from 'shared/icons/tick_regular.svg'
import { Paper } from 'shared/ui/paper'
import { Option } from 'shared/ui/select-label/model'

import styles from './styles.module.scss'

interface OptionItem extends Option {
  prefix?: ReactNode
}

interface Props {
  value?: Option
  listOption?: OptionItem[]
  scrollToSelected?: boolean
  onChange?: (name: Option) => void
}

export const BlockSelect = ({
  value,
  onChange,
  listOption,
  scrollToSelected = false,
}: Props) => {
  const { t } = useTranslation()
  const selectedOptionRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (scrollToSelected) {
      selectedOptionRef.current?.scrollIntoView({ block: 'center' })
    }
  }, [scrollToSelected])

  const onClickHandler = (name: Option) => {
    onChange?.(name)
  }

  return (
    <div>
      <Paper padding={[0]}>
        <div className={styles.wrapperOptions}>
          {listOption?.map((item, index) => (
            <div
              key={`option-${item.name}-${index}`}
              ref={value?.value === item.value ? selectedOptionRef : undefined}
              onClick={() => onClickHandler(item)}
              className={styles.option}
            >
              <div className={styles.left}>
                {item?.prefix && item.prefix}

                <span className={styles.name}> {t(item?.name)} </span>
              </div>

              <div className={styles.indicator}>
                {value?.value === item.value ? (
                  <div className={styles.activeRadio}>
                    <img
                      src={TickRegularIcon}
                      alt=""
                    />
                  </div>
                ) : (
                  <div className={styles.unActiveRadio} />
                )}
              </div>
            </div>
          ))}
        </div>
      </Paper>
    </div>
  )
}
